import dayjs from 'dayjs';

import UserStore from '../../modules/common/UserStore';

export default (date: string | number): string => {
	const locale = UserStore.getUser().locale;
	return dayjs(date).locale(locale).format('L HH:mm:ss (Z)');
};
